var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('b-button',{staticClass:"m-t-15 m-b-25",attrs:{"block":"","variant":"primary"},on:{"click":_vm.guardar}},[_vm._v(" Guardar ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }